import React, { useState } from "react";

export default function RoundHistory({ rounds, roundHistory, roundIndex, phase }) {
  const [hovered, setHovered] = useState(null);

  if (!rounds || rounds.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5 rounded-2xl border border-slate-200 bg-white px-4 py-3">
      {rounds.map((round) => {
        const isPast =
          phase === "break"
            ? round.index <= roundIndex
            : round.index < roundIndex;
        const isCurrent = phase === "question" && round.index === roundIndex;
        const perf = roundHistory[round.index];
        const isTooltipable = (isPast || isCurrent) && Boolean(round.thumb);

        let squareClass =
          "flex h-8 w-8 items-center justify-center rounded-lg transition select-none cursor-default ";
        let inner;

        if (isCurrent) {
          squareClass += "bg-amber-50 border-2 border-amber-400 ring-2 ring-amber-100";
          inner = (
            <span className="h-2 w-2 animate-pulse rounded-full bg-amber-400" />
          );
        } else if (isPast) {
          if (perf?.isCorrect) {
            squareClass += "bg-emerald-100 border border-emerald-300";
            inner =
              perf.speedRank && perf.speedRank <= 3 ? (
                <span className="text-[9px] font-black text-amber-600">
                  #{perf.speedRank}
                </span>
              ) : (
                <span className="text-[11px] font-bold text-emerald-600">✓</span>
              );
          } else {
            squareClass += "bg-rose-100 border border-rose-200";
            inner = (
              <span className="text-[11px] font-bold text-rose-400">✗</span>
            );
          }
        } else {
          squareClass += "bg-slate-50 border border-slate-100";
          inner = (
            <span className="text-[9px] font-bold text-slate-300">
              {round.index}
            </span>
          );
        }

        return (
          <div
            key={round.index}
            className="relative"
            onMouseEnter={() => isTooltipable && setHovered(round.index)}
            onMouseLeave={() => setHovered(null)}
          >
            <div className={squareClass}>{inner}</div>

            {hovered === round.index && isTooltipable && (
              <div
                className="absolute bottom-full left-1/2 z-30 mb-2 -translate-x-1/2 rounded-2xl border border-slate-200 bg-white p-2 shadow-xl"
                style={{ minWidth: 120, maxWidth: 160 }}
              >
                {round.thumb && (
                  <img
                    src={round.thumb}
                    alt={`Round ${round.index}`}
                    className="mb-1.5 h-20 w-full rounded-xl object-cover"
                  />
                )}
                {isCurrent && (
                  <div className="text-center text-xs text-slate-400">
                    En cours...
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
